import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

class Vector extends GeomObject {
    constructor (originString, valueString, color) {
        if (arguments.length === 3) {
            super(window.cabri.emsc.createVector3(originString, valueString));
            this.color = color || "#7F7F7F";
        }
        else {
            super(originString);
            this.curve_color1 =
                this.getColorAttribute("curve_color1", "#7F7F7F");
            this.curve_radius = this.getFloatStyleAttribute("curve_radius", 1);
            this.coords = null;
        }
        // those two are read from the C in updateFromPeer
        this.basePoint = [0, 0, 0, 1];
        this.vector = [100, 100, 100];
    }

    updateFromPeer () {
        if (this.alreadyCheckedInLastCycle) {
            return this.updatedInLastCycle;
        }
        this.alreadyCheckedInLastCycle = true;
        let coords = null;
        try {
            coords = window.cabri.emsc.getVector3Info(this.objectId);
            if (typeof (this.coords) == "undefined" || this.coords === null) {
                this.coords = [...coords];
                this.updatedInLastCycle = true;
            }
            else {
                this.updatedInLastCycle = this.forceUpdateInNextCycle;
                // check if it has changed
                for (let i = 0; i < 7; i++) {
                    this.updatedInLastCycle = this.coords[i] !== coords[i];
                    if (this.updatedInLastCycle) {
                        break;
                    }
                }
            }
        } catch (e) {
            console.log("Issue at updating.", e);
        } finally {
            if (coords) cabri.emsc._free(coords);
        }

        if (!this.updatedInLastCycle) {
            return;
        }

        // do the change
        this.forceUpdateInNextCycle = false;
        for (let i = 0; i < 3; i++) {
            this.basePoint[i] = coords[i] / coords[3];
        }
        for (let j = 0; j < 3; j++) {
            this.vector[j] = coords[j + 4];
        }
        this.createTube();
        // store for next cycle
        for (let i = 0; i < 7; i++) {
            this.coords[i] = coords[i];
        }
    }

    createTube () {
        if (this.noDisplay || this.hidden) return;
        if (this.bSegment) {
            this.bSegment.dispose(false, true);
        }
        const a = this.basePoint, v = this.vector,
            b1 = [a[0] + 0.9 * v[0], a[1] + 0.9 * v[1], a[2] + 0.9 * v[2]],
            b = [a[0] + v[0], a[1] + v[1], a[2] + v[2]];
        this.bSegment = BABYLON.MeshBuilder.CreateTube("Vector" + this.objectId,
            {
                path: [
                    new BABYLON.Vector3(a[0], a[2], a[1]),
                    new BABYLON.Vector3(b1[0], b1[2], b1[1]),
                    new BABYLON.Vector3(b1[0], b1[2], b1[1]),
                    new BABYLON.Vector3(b[0], b[2], b[1])],
                radiusFunction: (i, d) => {
                    switch (i) {
                        case 0:
                            return 0.05 * this.curve_radius;
                        case 1:
                            return 0.05 * this.curve_radius;
                        case 2:
                            return 0.1 * this.curve_radius;
                        case 3:
                            return 0;  //0*this.curve_radius;
                    }
                },
                tesselation: 16,    // default is 64
            },
            cabri.scene);
        //this.bSegment.isVisible = false;

        super.markColor(this.bSegment, this.curve_color1);
        super.registerHighlighter(this.bSegment);
    }

    move (x, y, z, a, b, c) {
        this.basePoint = [x, y, z];
        this.vector = [a, b, c];
        cabri.notifyFileDirty();
        // TODO: adjust
        console.log("Please implement move!");
        this.forceUpdateInNextCycle = true;
    }

    dispose () {
        if (this.bSegment) {
            this.bSegment.dispose(false, true);
        }
        super.dispose();
    }

}

export {Vector}